import { selector } from "./recoilSelectors";
import { quickRouteCoordinatesState } from "./quickRouteState";
import { findAssigneeForJobState } from "./viewState";

export const actionPanelModeState = selector({
    key: "action.panel.mode",
    get: ({ get }) => {
        const quickRouteCoordinates = get(quickRouteCoordinatesState);
        if (quickRouteCoordinates.length > 0) {
            return "quickroute";
        }
        if (get(findAssigneeForJobState)) {
            return "findassignee";
        }
        return "none";
    },
});

